<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="`SEND YOUR TEXT MESSAGE AS VOICE`"
    />
    <div class="modal-content flex flex-col items-center">
      <!-- <resizable-text-area
        ref="messageInput"
        class="input"
        :min-height="4"
        v-model="message"
      /> -->
      <div class="flex flex-row">
        <strong>Your message:</strong>&nbsp;
        <span>{{ message }}</span>
      </div>
      <div v-if="audioUrl" class="flex flex-col items-center mt-3 mb-3">
        <div>Preview the voice message:</div>
        <audio  controls class="skip-context-menu mt-2 mb-2">
          <source :src="`${audioUrl}`" />
        </audio>
      </div>
      <div>
        <button
          class="mt-2 button primary"
          @click="generateVoiceMessage"
          :disabled="processing || blobId"
        >
          Generate Voice Message
        </button>
        <button
          class="mt-2 button primary"
          @click="sendVoiceMessage"
          :disabled="!blobId || processing"
        >
          Send Voice Message
        </button>
      </div>
    </div>
  </woot-modal>
</template>

<script>

import ResizableTextArea from 'shared/components/ResizableTextArea';
import MessageApi from '../../../../api/inbox/message';
export default {
  components: {
    ResizableTextArea,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    conversationId: {
      type: Number,
      default: undefined,
    },
    message: {
      type: String,
      default: ''
    },
    latestGeneratedMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      processing: false,
      blobId: undefined,
      audioUrl: ''
    };
  },
  computed: {
  },
  watch: {
    message(newVal, oldVal) {
      if (this.latestGeneratedMessage != newVal) {
        this.processing = false;
        this.blobId = undefined;
        this.audioUrl = '';
      }
    }
  },
  methods: {
    generateVoiceMessage() {
      this.processing = true
      MessageApi.generateVoiceMessage(this.conversationId, this.message).then(res => {
        this.blobId = res.data.blob_id;
        this.audioUrl = res.data.audio_url;
        this.processing = false;
        this.latestGeneratedMessage = this.message;
      })
    },
    sendVoiceMessage(){
      MessageApi.sendVoiceMessage(this.conversationId, this.blobId);
      this.$emit('on-sent');
      this.onClose();
    },
    onClose() {
      this.$emit('cancel');
    },
    onChangeFile(event) {
    },
  }
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.modal-content {
  padding: 1.5625rem 2rem;
}

</style>

